import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkedAlt } from '@fortawesome/free-solid-svg-icons';

export default function RedeCredenciada() {
  return (
    <div className="w-full bg-gradient-to-b from-white to-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Cabeçalho */}
        <div className="text-center mb-12">
          <FontAwesomeIcon
            icon={faMapMarkedAlt}
            className="text-orange-600 text-5xl mb-4"
          />
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Rede Credenciada Nacional
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Atendimento odontológico de qualidade em todo o Brasil
          </p>
        </div>

        {/* Conteúdo Principal - Layout Lado a Lado */}
        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            {/* Lado Esquerdo - Informações */}
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                Cobertura em Todo o Território Nacional
              </h3>
              <p className="text-lg text-gray-600 mb-8">
                Rede credenciada presente em todos os estados brasileiros
              </p>

              <div className="grid grid-cols-2 gap-4">
                <div className="bg-gradient-to-br from-orange-50 to-orange-100 p-4 rounded-lg border-2 border-orange-200 hover:border-orange-400 transition-colors">
                  <p className="text-lg font-semibold text-gray-900">Norte</p>
                </div>
                <div className="bg-gradient-to-br from-orange-50 to-orange-100 p-4 rounded-lg border-2 border-orange-200 hover:border-orange-400 transition-colors">
                  <p className="text-lg font-semibold text-gray-900">
                    Nordeste
                  </p>
                </div>
                <div className="bg-gradient-to-br from-orange-50 to-orange-100 p-4 rounded-lg border-2 border-orange-200 hover:border-orange-400 transition-colors">
                  <p className="text-lg font-semibold text-gray-900">
                    Centro-Oeste
                  </p>
                </div>
                <div className="bg-gradient-to-br from-orange-50 to-orange-100 p-4 rounded-lg border-2 border-orange-200 hover:border-orange-400 transition-colors">
                  <p className="text-lg font-semibold text-gray-900">Sudeste</p>
                </div>
                <div className="bg-gradient-to-br from-orange-50 to-orange-100 p-4 rounded-lg border-2 border-orange-200 hover:border-orange-400 transition-colors">
                  <p className="text-lg font-semibold text-gray-900">Sul</p>
                </div>
                <div className="bg-gradient-to-br from-orange-50 to-orange-100 p-4 rounded-lg border-2 border-orange-200 hover:border-orange-400 transition-colors">
                  <p className="text-lg font-semibold text-gray-900">
                    Todas as Capitais
                  </p>
                </div>
              </div>
            </div>

            {/* Lado Direito - Mapa */}
            <div className="flex justify-center items-center">
              <img
                src="https://odontoempresa.sulamerica.com.br/static/media/brazil-pin.950fbc87.webp"
                alt="Mapa do Brasil com cobertura nacional"
                className="w-full max-w-md h-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
